import communicate from 'src/api/communicate';
import toastrError from 'src/helpers/toastr/toastrError';
import { getQueryStringFromObject } from 'src/utils/objects';
import Utils from 'src/utils';
import { loadExcelExport } from 'src/store/actions/excelActions';
export var UnscheduledWorkReportActions;
(function (UnscheduledWorkReportActions) {
    UnscheduledWorkReportActions["GET_UNSCHEDULED_WORK_REPORT_REQUEST"] = "GET_UNSCHEDULED_WORK_REPORT_REQUEST";
    UnscheduledWorkReportActions["GET_UNSCHEDULED_WORK_REPORT_SUCCESS"] = "GET_UNSCHEDULED_WORK_REPORT_SUCCESS";
    UnscheduledWorkReportActions["GET_UNSCHEDULED_WORK_REPORT_FAIL"] = "GET_UNSCHEDULED_WORK_REPORT_FAIL";
})(UnscheduledWorkReportActions || (UnscheduledWorkReportActions = {}));
export function getUnscheduledWorkReportRequest() {
    return { type: UnscheduledWorkReportActions.GET_UNSCHEDULED_WORK_REPORT_REQUEST };
}
export function getUnscheduledWorkReportSuccess(payload) {
    return { type: UnscheduledWorkReportActions.GET_UNSCHEDULED_WORK_REPORT_SUCCESS, payload };
}
export function getUnscheduledWorkReportFail() {
    return { type: UnscheduledWorkReportActions.GET_UNSCHEDULED_WORK_REPORT_FAIL };
}
export function getUnscheduledWorkReport(params) {
    return (dispatch) => {
        dispatch(getUnscheduledWorkReportRequest());
        return communicate({ url: 'Reports/OffScheduleReport', method: 'get', getParams: getQueryStringFromObject(params) })
            .then(({ data }) => {
            const result = data.Data;
            dispatch(getUnscheduledWorkReportSuccess(result));
        })
            .catch((error) => {
            console.error(error);
            dispatch(getUnscheduledWorkReportFail());
            toastrError(error);
        });
    };
}
export function loadExcel(params) {
    return (dispatch) => {
        const request = {
            url: 'Reports/OffScheduleReportExcel',
            query: Utils.objects.getQueryStringFromObject(params)
        };
        return dispatch(loadExcelExport(request));
    };
}
